module.exports = __webpack_public_path__ + "static/labco.a628887a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/labco.png
// module id = 801
// module chunks = 219805994829571